import { render } from "./AdminPanelView.vue?vue&type=template&id=1547266b&scoped=true"
import script from "./AdminPanelView.vue?vue&type=script&lang=js"
export * from "./AdminPanelView.vue?vue&type=script&lang=js"

import "./AdminPanelView.vue?vue&type=style&index=0&id=1547266b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1547266b"]])

export default __exports__